import { useSelector } from "react-redux"
import { DataStatus } from "../../../domain/enums"
import useProviderData from "../../../domain/PracticeProviders/useProviderData"
import { selectProvider } from "../../../domain/Provider/model"
import { Provider } from "../../../domain/Provider/schema"
import { isEmpty } from "lodash"
import { ProviderTypeDisplayId } from "../../../domain/enums/displayId.enum"

export interface UnregisteredBadgeProps {
  force?: boolean
  providerId?: string
}

const UnregisteredBadge: React.FC<UnregisteredBadgeProps> = ({
  force,
  providerId,
}: UnregisteredBadgeProps) => {
  switch (force) {
    case true:
      return <TheBadge />
    case false:
      return <></>
    default:
      return providerId ? (
        <BadgeByServx providerId={providerId} />
      ) : (
        <BadgeByRedux />
      )
  }
}

const BadgeByRedux: React.FC = () => {
  const provider = useSelector(selectProvider)
  return (
    !isProviderRegistered(provider) &&
    !isProviderManaged(provider) && <TheBadge />
  )
}

const BadgeByServx: React.FC<UnregisteredBadgeProps> = ({
  providerId,
}: UnregisteredBadgeProps) => {
  const { provider, useProviderDataStatus } = useProviderData(providerId ?? "")
  if (useProviderDataStatus !== DataStatus.LOADED) return null
  return (
    !isProviderRegistered(provider) &&
    !isProviderManaged(provider) && <TheBadge />
  )
}

const TheBadge: React.FC = () => {
  return (
    <button
      disabled
      className="w-[124px] h-[23px] bg-[#660F8B] rounded-lg inline-flex items-center justify-center"
    >
      <div className="relative w-[12px] h-[12px] overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
        <svg
          className="absolute w-[12px] h-[12px] text-[#660F8B] left-[0px]"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
            clipRule="evenodd"
          ></path>
        </svg>
      </div>
      <span className="text-small text-white pl-1">Unregistered</span>
    </button>
  )
}

export const isProviderRegistered = (provider: Provider | null): boolean =>
  !isEmpty(provider) && !isEmpty(provider.userId)

export const isProviderManaged = (provider: Provider | null): boolean =>
  !isEmpty(provider) &&
  provider.providerTypeDisplayId === ProviderTypeDisplayId.MANAGED

export default UnregisteredBadge
